<template>
  <v-row justify="center">
    <v-dialog v-model="localValue" max-width="360" content-class="alert-modal">
      <v-card>
        <v-card-title class="headline">{{ title }}</v-card-title>
        <v-card-text>
          {{ message }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="handleClose" :large="$vuetify.breakpoint.mdAndUp">
            戻る
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'AlertModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '通知'
    },
    message: {
      type: String,
      default: ''
    },
    onClose: {
      type: Function,
      required: false
    }
  },
  data() {
    return {
      localValue: this.value
    };
  },
  watch: {
    value(val) {
      this.localValue = val;
    }
  },
  methods: {
    handleClose() {
      this.localValue = false;
      this.$emit('input', false);
      this.onClose?.();
    }
  }
};
</script>

<style>
@media only screen and (min-width: 960px) {
  .alert-modal .v-card__text {
    font-size: 18px !important;
    text-align: center;
  }
}
</style>